import { IconButton, Tooltip } from "@material-ui/core";

import InfoIcon from "@material-ui/icons/Info";

export default function InfoEmail() {
    return (
        <Tooltip
            arrow
            placement="top"
            title="El correo proporcionado será usado para la recuperación de las credenciales."
        >
            <IconButton>
                <InfoIcon />
            </IconButton>
        </Tooltip>
    );
}
